import { AxiosResponse } from 'axios'
import { OliveUser } from 'src/types/oliveUser'
import { OliveUserRoleType } from 'src/types/roleType'

import axios from '../../axios'

export type OliveUserUpdateRequestBody = {
  name: string
  phoneNumber?: string
  roleType: OliveUserRoleType
  isMfaActive: boolean
}

export const updateOliveUser = async (
  id: string,
  requestBody: OliveUserUpdateRequestBody
): Promise<AxiosResponse> => {
  return axios.get(`/api/csrf-cookie`).then(() => {
    const response = axios
      .put<{ data: OliveUser }>(`/api/olive-users/${id}`, requestBody)
      .catch((error) => {
        return error.response
      })

    return response
  })
}
